import React from "react";
import Parser from "html-react-parser";
import { useSelector } from "react-redux";
import { animations } from "react-animation";
import "./BarraIntermedia.css";

//const ROOT = process.env.REACT_APP_CMS_STATIC;

function BarraIntermedia(props) {
  const { barraIntermedia } = useSelector(({ Base }) => Base.ContenidoCMS);

  return (
    <div style={{ animation: animations.fadeIn }}>
      {barraIntermedia && (
        <div className="contenedor-barra">
          <div className="contenido-barra d-flex justify-content-between">
            <div className="descripcionBarra">
              {Parser(barraIntermedia[0].descripcion.html)}
            </div>          
          </div>
        </div>
      )}
    </div>
  );
}

export default BarraIntermedia;
